module.exports = __webpack_public_path__ + "static/images/cross-regular-circle.92621da7452822898323b812e8fe1267.svg";